import React from "react";
import * as styles from "./FullWidthSummaryDisplay.module.css";
import { ComponentProps, ComponentWidth } from "../../../types";
import { SummaryTileProps } from "../../elements/SummaryTile/SummaryTile";
import { MediaDynamicHero } from "../DynamicHero/MediaDynamicHero";
import AnimationWrapper from "../../containers/AnimationWrapper";

interface Props extends ComponentProps, ComponentWidth {
  summaries: SummaryTileProps[];
}

export const FullWidthSummaryDisplay: React.FC<Props> = ({
  summaries,
  width,
  ...props
}) => {
  if (!summaries && !summaries[0]) return null;

  const summary = summaries[0];
  const constainerStyles =
    width === "contained"
      ? `${styles.contained} ${styles.container}`
      : styles.container;
  const link =
    summary.ctaHref && summary.ctaLabel
      ? [
          {
            id: "ctaLink",
            href: summary.ctaHref,
            label: summary.ctaLabel,
            target: summary.ctaTarget || "_self",
          },
        ]
      : undefined;

  return (
    <AnimationWrapper className={constainerStyles} behavior={"fadeInUp"}>
      <MediaDynamicHero
        desktopImage={summary.image}
        mobileImage={summary.smallImage}
        title={summary.subhead}
        cta={link}
        height="tall"
        overlayStyle="solid"
        headingType="h2"
        text={summary.text?.value !== "<p><br></p>" ? summary.text : undefined}
        {...props}
      />
    </AnimationWrapper>
  );
};
